document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.faq-item__header').forEach(button => {
        button.addEventListener('click', () => {
            const item = button.closest('.faq-item');
            item.classList.toggle('faq-item--active');
        });
    });
});
